import ajax from '@/plugin/ajax'
export const addBlackBulk = function (emails, force) {
    emails = typeof emails === 'string' ? [emails] : emails
    return ajax({
        method: 'post',
        // url: '/vipapi/address/addBlack_v2',
        url: '/vipapi/address/personal_wb',
        data: {
            emails: emails,
            isblack: 1,
            force: force
        }
    })
}
export const addWhiteBulk = function (emails, force) {
    return ajax({
        method: 'post',
        url: 'vipapi/address/personal_wb',
        data: {
            emails: emails, // ["zhou@163.com","@163.com"]
            isblack: 0,
            force: force
        }
    })
}
export const delBlackBulk = function (emails) {
    return ajax({
        method: 'DELETE',
        url: 'vipapi/address/personal_wb',
        data: {
            emails: emails,
            isblack: 1
        }
    })
}
export const delWhiteBulk = function (emails) {
    return ajax({
        method: 'DELETE',
        url: 'vipapi/address/personal_wb',
        data: {
            emails: emails,
            isblack: 0
        }
    })
}
export const getBlackBulk = function () {
    return ajax({
        method: 'GET',
        url: 'vipapi/address/personal_wb?isblack=1'
    })
}
export const getWhiteBulk = function () {
    return ajax({
        method: 'GET',
        url: 'vipapi/address/personal_wb?isblack=0'
    })
}



// WEBPACK FOOTER //
// ./src/service/whiteblackService.js